module.exports = __webpack_public_path__ + "img/TS_ICON_COMIC_AR.52384b79.png";